import { Check, Copy } from "lucide-react";

/**
 * Single labelled, copy-able block of generated outreach text
 * (subject / message / followup / pitch angle).
 */
export default function OutreachBlock({ label, text, onCopy, copied, big }) {
  return (
    <div className="surface p-5">
      <div className="flex justify-between items-center mb-3">
        <div className="label-eyebrow">{label}</div>
        <button onClick={onCopy} className="text-xs uppercase tracking-widest text-ink-muted hover:text-volt flex items-center gap-1">
          {copied ? <Check className="w-3.5 h-3.5 text-volt" /> : <Copy className="w-3.5 h-3.5" />} {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <p className={`whitespace-pre-wrap leading-relaxed ${big ? "text-base" : "text-sm"} text-white`}>{text}</p>
    </div>
  );
}
